import React from 'react';
import { BASE_URL } from '@apps/config';
import { serializeJsonLd } from '@apps/utils/serialize-json-ld';
import Head from 'next/head';

import { BreadcrumbStructuredDataProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const BreadcrumbStructuredData: React.FC<
  BreadcrumbStructuredDataProps
> = (props) => {
  const { items, localePrefix } = props;

  // =============== VARIABLES
  // `Breadcrumb` types `title` as `ReactNode`, only plain strings can name a `ListItem`
  const entries = items.filter((item) => {
    return typeof item.title === 'string' && !!item.title.trim();
  });

  if (entries.length < 1) return null;

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: entries.map((item, index) => {
      // `/zh/` 308-redirects to `/zh`, so the joined path must not keep a trailing slash
      const path = `${localePrefix}${item.url ?? ''}`.replace(/\/$/, '') || '/';

      return {
        '@type': 'ListItem',
        position: index + 1,
        name: item.title,
        // the trailing crumb is the current page and carries no url, so it stays item-less
        ...(item.url ? { item: `${BASE_URL}${path}` } : {}),
      };
    }),
  };

  // =============== VIEWS
  return (
    <Head>
      <script
        type="application/ld+json"
        key="breadcrumb-schema"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(breadcrumbSchema) }}
      />
    </Head>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default BreadcrumbStructuredData;
